var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var _a;
import CheckCircleIcon from '@material-ui/icons/CheckCircle';
import CloseIcon from '@material-ui/icons/Close';
import InfoIcon from '@material-ui/icons/Info';
import WarningIcon from '@material-ui/icons/Warning';
import React from 'react';
import { Link } from 'react-router-dom';
import { toast } from 'react-toastify';
import styled from 'styled-components';
export var ODToastType;
(function (ODToastType) {
    ODToastType["Success"] = "Success";
    ODToastType["Error"] = "Error";
    ODToastType["Info"] = "Info";
})(ODToastType || (ODToastType = {}));
var ToastTitle = styled.span(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  font-size: 13px;\n  font-weight: bold;\n  font-stretch: normal;\n  font-style: normal;\n  line-height: normal;\n  letter-spacing: 0.46px;\n  padding-top: 10px;\n  color: #000000;\n"], ["\n  font-size: 13px;\n  font-weight: bold;\n  font-stretch: normal;\n  font-style: normal;\n  line-height: normal;\n  letter-spacing: 0.46px;\n  padding-top: 10px;\n  color: #000000;\n"])));
var ToastBody = styled.span(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  font-size: 13px;\n  font-weight: normal;\n  font-stretch: normal;\n  font-style: normal;\n  line-height: normal;\n  letter-spacing: 0.46px;\n  padding-bottom: ", "px;\n  color: #616b75;\n"], ["\n  font-size: 13px;\n  font-weight: normal;\n  font-stretch: normal;\n  font-style: normal;\n  line-height: normal;\n  letter-spacing: 0.46px;\n  padding-bottom: ", "px;\n  color: #616b75;\n"])), function (p) { return (p.hasTitle ? 8 : 1); });
var config = (_a = {},
    _a[ODToastType.Success] = { color: '#4dbd74', icon: React.createElement(CheckCircleIcon, null) },
    _a[ODToastType.Error] = { color: '#e8bb41', icon: React.createElement(WarningIcon, null) },
    _a[ODToastType.Info] = { color: '#63c2de', icon: React.createElement(InfoIcon, null) },
    _a);
export var ODToast = function (_a) {
    var toastType = _a.toastType, title = _a.title, message = _a.message, linkTo = _a.linkTo, linkText = _a.linkText, onClickClose = _a.onClickClose;
    var _b = config[toastType], color = _b.color, icon = _b.icon;
    return (React.createElement("div", { style: {
            display: 'flex',
            borderLeft: "4px solid " + color,
            padding: 0,
            margin: 0,
            position: 'relative',
            height: '100%',
        } },
        React.createElement("div", { style: {
                flexGrow: 1,
                marginLeft: 16,
                position: 'relative',
                top: -1,
                color: color,
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'center',
            } }, icon),
        React.createElement("div", { style: { flexGrow: 99, display: 'flex', flexDirection: 'column', height: '100%', paddingLeft: 14 } },
            title && (React.createElement("div", { style: { flexGrow: 1, display: 'flex', flexDirection: 'column', justifyContent: 'center' } },
                React.createElement(ToastTitle, null, title))),
            React.createElement("div", { style: { flexGrow: 1, display: 'flex', flexDirection: 'column', justifyContent: 'center' } },
                React.createElement(ToastBody, { hasTitle: !!title },
                    message,
                    linkTo ? React.createElement(Link, { to: { pathname: linkTo }, target: "_blank" }, linkText) : null))),
        React.createElement("div", { style: { marginRight: 14, display: 'flex', flexDirection: 'column', justifyContent: 'center' }, onClick: onClickClose },
            React.createElement(CloseIcon, null))));
};
export function showODToast(type, title, message, options) {
    if (options === void 0) { options = {}; }
    var toastId = null;
    var handleClose = function () {
        toast.dismiss(toastId);
    };
    var op = __assign({ hideProgressBar: true, closeButton: false }, options);
    toastId = toast(React.createElement(ODToast, { toastType: type, title: title, message: message, onClickClose: handleClose }), op);
}
export function showODLinkToast(type, title, message, linkTo, linkText, options) {
    if (options === void 0) { options = {}; }
    var toastId = null;
    var handleClose = function () {
        toast.dismiss(toastId);
    };
    var op = __assign({ hideProgressBar: true, closeButton: false }, options);
    toastId = toast(React.createElement(ODToast, { toastType: type, title: title, message: message, linkTo: linkTo, linkText: linkText, onClickClose: handleClose }), op);
}
var templateObject_1, templateObject_2;
//# sourceMappingURL=ODToast.js.map